module.exports = __webpack_public_path__ + "img/clipboard.a512a315.svg";